export default {"src":"/_next/static/media/new-gs-wordmark-logo.b4246b8d.svg","height":44,"width":320,"blurWidth":0,"blurHeight":0};